
export const SYSTEM_USER_NAVIGATION_ITEMS = [
    // {
    //     id: MOD_PATIENT.id,
    //     title: MOD_PATIENT.name_plural,
    //     url: MOD_PATIENT.routes.list,
    //     icon: <User className="text-purple-700 w-4 h-4" />,
    //     bgClass: "bg-purple-100 text-purple-700 hover:bg-purple-200 border border-purple-200"
    // }, 
]
export const PATIENT_NAVIGATION_ITEMS = [

]